var React = require('react');

function HOLLOWCubeInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"_x31__hollow_2_"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"HOLLOW_cube","transform":"translate(1.000000, 1.000000)","stroke":"#555C65","strokeWidth":"2.5"},[React.createElement("path",{"d":"M32.13,72.54 L0.87,54.58 L0.87,17.67 L32.13,0.71 C42.44,6.36 52.75,12.02 63.06,17.67 L63.06,54.58 L32.13,72.54 Z","fill":"#2C3D44","fillRule":"nonzero","key":0}),React.createElement("polyline",{"points":"0.87 17.67 31.96 35.8 63.06 17.67","key":1}),React.createElement("line",{"x1":"32.13","y1":"72.54","x2":"31.96","y2":"35.8","fill":"#2C3D44","fillRule":"nonzero","key":2})]))]);
}

HOLLOWCubeInline.defaultProps = {"width":"66px","height":"75px","viewBox":"0 0 66 75","version":"1.1"};

module.exports = HOLLOWCubeInline;

HOLLOWCubeInline.default = HOLLOWCubeInline;
